import React from 'react';

export const CheckboxForm = ({ component, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(component.id, {
      specificAttrs: { ...component.specificAttrs, [field]: value }
    });
  };

  const { specificAttrs } = component;

  return (
    <div style={{ display: 'grid', gap: '12px' }}>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Label
        </label>
        <input
          type="text"
          value={specificAttrs.label}
          onChange={(e) => handleChange('label', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Name
        </label>
        <input
          type="text"
          value={specificAttrs.name}
          onChange={(e) => handleChange('name', e.target.value)}
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div>
        <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', marginBottom: '4px', color: '#4B5563' }}>
          Help Text
        </label>
        <input
          type="text"
          value={specificAttrs.helpText || ''}
          onChange={(e) => handleChange('helpText', e.target.value)}
          placeholder="Optional help text"
          style={{
            width: '100%',
            padding: '6px 10px',
            fontSize: '13px',
            border: '1px solid #D1D5DB',
            borderRadius: '6px'
          }}
        />
      </div>
      <div style={{ display: 'flex', gap: '16px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.checked}
            onChange={(e) => handleChange('checked', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>Checked by default</span>
        </label>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={specificAttrs.disabled}
            onChange={(e) => handleChange('disabled', e.target.checked)}
          />
          <span style={{ fontSize: '12px', fontWeight: '500', color: '#4B5563' }}>Disabled</span>
        </label>
      </div>
    </div>
  );
};
